export const ctfAppClientId = process.env.REACT_APP_CTF_APP_CLIENT_ID || '';
export const ctfAppRedirectUri = process.env.REACT_APP_CTF_APP_REDIRECT_URI || '';